import { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import api from '../../services/api';
import brasao from '../../assets/img/brasao.png';
import '../../assets/css/styles.css';

function ForgotPasswordModal({ show, onHide, email }) {
  const [localEmail, setLocalEmail] = useState(email || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Reseta estados ao abrir o modal
  const handleShow = () => {
    setLocalEmail(email || '');
    setError('');
    setSuccess('');
  };

  const handleSendReset = async () => {
    setError('');
    setSuccess('');

    // Validação de email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!localEmail || !emailRegex.test(localEmail)) {
      setError('Por favor, informe um email válido.');
      return;
    }

    // Verifica se é email @sejus.df.gov.br
    if (localEmail.toLowerCase().endsWith('@sejus.df.gov.br')) {
      setError('A sua senha é a mesma utilizada no login da rede SEJUS');
      return;
    }

    setLoading(true);

    try {
      const response = await api.post('/password/forgot', {
        email: localEmail
      });

      if (response.data.success) {
        setSuccess(response.data.message);
        // Fecha o modal após 3 segundos
        setTimeout(() => {
          onHide();
        }, 3000);
      }
    } catch (err) {
      if (err.response?.data?.type === 'sejus_email') {
        setError(err.response.data.message);
      } else if (err.response?.status === 429) {
        setError('Muitas tentativas. Tente novamente em 1 hora.');
      } else {
        setError('Erro ao processar solicitação. Tente novamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal 
      show={show} 
      onHide={onHide}
      onShow={handleShow}
      centered
      className="forgot-password-modal"
      backdrop="static"
    >
      <Modal.Header className="flex-column border-0 pb-0">
        <div className="text-center mb-3">
          <img 
            src={brasao}
            alt="Brasão SSE-DF" 
            className="mb-2" 
            height="80"
          />
          <Modal.Title as="h3">Esqueceu sua senha?</Modal.Title>
        </div>
        <button 
          type="button" 
          className="btn-close btn-close-white position-absolute top-0 end-0 m-3"
          onClick={onHide}
          aria-label="Close"
        />
      </Modal.Header>
      
      <Modal.Body className="pt-0">
        <p className="text-muted mb-3">
          Informe seu email cadastrado para receber um link de redefinição de senha.
        </p>

        <Form.Group className="mb-3">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            placeholder="seu.email@exemplo.com"
            value={localEmail}
            onChange={(e) => setLocalEmail(e.target.value)}
            disabled={loading || success}
            autoFocus
          />
        </Form.Group>

        {error && (
          <Alert variant="danger" className="mb-3">
            {error}
          </Alert>
        )}

        {success && (
          <Alert variant="success" className="mb-3">
            <i className="bi bi-check-circle me-2"></i>
            {success}
          </Alert>
        )}

        {!success && (
          <div className="alert alert-info small">
            <i className="bi bi-info-circle me-2"></i>
            <strong>Importante:</strong>
            <ul className="mb-0 mt-2">
              <li>O link expira em 24 horas</li>
              <li>Verifique sua caixa de spam</li>
              <li>Se não receber o email, tente novamente</li>
            </ul>
          </div>
        )}

        <div className="d-flex gap-2 mt-4">
          <Button variant="secondary" onClick={onHide} disabled={loading} className="flex-fill">
            Cancelar
          </Button>
          <Button 
            onClick={handleSendReset}
            disabled={loading || success || !localEmail}
            className="flex-fill btn-login"
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Enviando...
              </>
            ) : (
              'Enviar Link'
            )}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ForgotPasswordModal;
